import { Component, Input } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { DishCreateObservationsPage } from '../../dish-create/dish-create-observations/dish-create-observations';


/**
 * Generated class for the DishViewPreparationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view-observations',
    templateUrl: 'dish-view-observations.html',
})
export class DishViewObservationsPage {
    @Input() dish: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public globals: Globals,) {
    }

    edit() {
        if (this.globals.checkLimitsByLicense('dishes','observations')) {
            this.navCtrl.push(DishCreateObservationsPage, {
                update: true,
                dish_uid: this.dish.UID,
                dish_name: this.globals.nameLangSelectDish(this.dish),
                observations: this.dish.observations,
                dish: this.dish,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }


}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view-observations/dish-view-observations.ts